import React, { Fragment } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
// views
import LoginNegocio from "./views/LoginNegocio";
import LoginDelivery from "./views/LoginDelivery";
import IndexPerfil from "./views/IndexPerfil";
import Dashboard from "./layouts/Dashboard";
import { UrlServicesProvider } from "./components/UrlServicesContext";

export default function App() {
  return (
    <Fragment>
      <UrlServicesProvider>
        <Router>
          <Route path="/" exact={true} component={IndexPerfil} />
          <Route path="/loginNegocio" exact={true} component={LoginNegocio} />
          <Route path="/loginDelivery" exact={true} component={LoginDelivery} />
          <Route path="/dashboard" exact={true} component={Dashboard} />
        </Router>
      </UrlServicesProvider>
    </Fragment>
  );
}
